/* eslint-disable new-cap */
import Vue from 'vue'
import Axios from 'axios'
import { Message } from 'element-ui'
import nprogress from '@/utils/nprogress'
export let baseURL = localStorage.mock ?
    process.env.VUE_APP_MOCK_API :
    process.env.VUE_APP_BASIC_API

let needLoadingRequestCount = 0

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        nprogress.start()
    }
    needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        nprogress.done()
    }
}

// 创建axios实例
const service = Axios.create({
    baseURL: baseURL,
    timeout: 150000
})

service.interceptors.request.use(
    config => {
        // if (localStorage.token) {
        //     config.headers['X-TOKEN'] = localStorage.token
        // }
        if(config.url && config.url.includes('/usp/get_pub_key')){
            //直接调用司机端接口
            baseURL = process.env.VUE_APP_KEY_URL;
            config.url = baseURL + config.url
        }
        showFullScreenLoading()
        return config
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
service.interceptors.response.use(
    ({ data }) => {
        tryHideFullScreenLoading()

        if (data.code === '-999' || data.code === 403001) {
            window.location.href = '/login'
            window.localStorage.clear()
            return
        }

        if (data.code === -404) {
            window.location.href = '/404'
            window.localStorage.clear()
            return
        }

        if (data.code === 1 || data.code === 200 || data.code === 201) {
            return data
        } else {
            Message.closeAll()
            Message({
                message: data.msg,
                showClose: true,
                type: 'error',
                duration: 3 * 1000
            })
            return ''
        }
    },
    err => {
        // 对响应错误做点什么
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = '请求错误'
                    break

                case 401:
                    err.message = '未授权，请登录'
                    break

                case 403:
                    err.message = '拒绝访问'
                    break

                case 404:
                    err.message = `请求地址出错: ${err.response.config.url}`
                    break

                case 408:
                    err.message = '请求超时'
                    break

                case 500:
                    err.message = '服务器内部错误'
                    break

                case 501:
                    err.message = '服务未实现'
                    break

                case 502:
                    err.message = '网关错误'
                    break

                case 503:
                    err.message = '服务不可用'
                    break

                case 504:
                    err.message = '网关超时'
                    break

                case 505:
                    err.message = 'HTTP版本不受支持'
                    break

                default:
                    err.message = '系统错误'
                    break
            }
        } else {
            err.message = '连接服务器失败!'
        }
        Message.closeAll()
        Message({
                message: err.message,
                showClose: true,
                type: 'error',
                duration: 3 * 1000
            })
            // 对响应错误做点什么
        return Promise.reject(err)
    }
)

Vue.prototype.$http = service

export default service